<template>
  <div class="d-flex align-end ga-3">
    <svg
      v-if="!selected_reached_lead_type"
      @click.stop.prevent="handleClickPermission()"
      :class="{
        'cursor-pointer': hasWritePermission,
        'disabled-module': !hasWritePermission,
      }"
      v-tooltip:top="!hasWritePermission ? `⛔ ${$t('not_authorized')}` : 'authorized'"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9902 22.5C11.525 22.5 11.067 22.4698 10.6182 22.4112L10.5535 22.907C9.58346 22.7805 8.65312 22.5276 7.77957 22.1653L7.97109 21.7035C7.11774 21.3496 6.32095 20.8863 5.59827 20.3309L5.29361 20.7274C4.53158 20.1418 3.84843 19.4587 3.26284 18.6966L3.6593 18.392C3.10395 17.6693 2.64065 16.8725 2.28678 16.0191L1.82492 16.2107C1.46267 15.3371 1.20975 14.4068 1.08321 13.4367L1.57901 13.372C1.52046 12.9232 1.49023 12.4653 1.49023 12C1.49023 11.5347 1.52046 11.0768 1.57901 10.628L1.08321 10.5633C1.20975 9.59323 1.46267 8.66289 1.82492 7.78933L2.28678 7.98086C2.64065 7.12751 3.10395 6.33072 3.6593 5.60804L3.26284 5.30337C3.84843 4.54134 4.53158 3.85819 5.29361 3.27261L5.59827 3.66907C6.32095 3.11371 7.11774 2.65042 7.9711 2.29655L7.77957 1.83469C8.65312 1.47244 9.58347 1.21951 10.5535 1.09297L10.6182 1.58877C11.067 1.53023 11.525 1.5 11.9902 1.5C12.4555 1.5 12.9134 1.53023 13.3623 1.58877L13.4269 1.09298C14.397 1.21951 15.3273 1.47244 16.2009 1.83469L16.0094 2.29655C16.8627 2.65042 17.6595 3.11371 18.3822 3.66907L18.6869 3.27261C19.4489 3.8582 20.132 4.54135 20.7176 5.30338L20.3212 5.60804C20.8765 6.33072 21.3398 7.12751 21.6937 7.98086L22.1555 7.78933C22.5178 8.66289 22.7707 9.59323 22.8973 10.5633L22.4015 10.628C22.46 11.0768 22.4902 11.5347 22.4902 12C22.4902 12.4653 22.46 12.9232 22.4015 13.372L22.8973 13.4367C22.7707 14.4068 22.5178 15.3371 22.1555 16.2107L21.6937 16.0191C21.3398 16.8725 20.8765 17.6693 20.3212 18.392L20.7176 18.6966C20.132 19.4587 19.4489 20.1418 18.6869 20.7274L18.3822 20.3309C17.6595 20.8863 16.8627 21.3496 16.0094 21.7035L16.2009 22.1653C15.3273 22.5276 14.397 22.7805 13.4269 22.907L13.3623 22.4112C12.9134 22.4698 12.4555 22.5 11.9902 22.5Z"
        stroke="#B3B3B3"
        stroke-dasharray="3 3"
      />
      <path
        d="M17.0497 10.9999H12.9997V6.93994C12.9997 6.67472 12.8943 6.42037 12.7068 6.23283C12.5193 6.0453 12.2649 5.93994 11.9997 5.93994C11.7345 5.93994 11.4801 6.0453 11.2926 6.23283C11.105 6.42037 10.9997 6.67472 10.9997 6.93994V10.9999H6.92969C6.66447 10.9999 6.41012 11.1053 6.22258 11.2928C6.03504 11.4804 5.92969 11.7347 5.92969 11.9999C5.92969 12.2652 6.03504 12.5195 6.22258 12.707C6.41012 12.8946 6.66447 12.9999 6.92969 12.9999H10.9997V17.0599C10.9997 17.3252 11.105 17.5795 11.2926 17.767C11.4801 17.9546 11.7345 18.0599 11.9997 18.0599C12.2649 18.0599 12.5193 17.9546 12.7068 17.767C12.8943 17.5795 12.9997 17.3252 12.9997 17.0599V12.9999H17.0597C17.3249 12.9999 17.5793 12.8946 17.7668 12.707C17.9543 12.5195 18.0597 12.2652 18.0597 11.9999C18.0597 11.7347 17.9543 11.4804 17.7668 11.2928C17.5793 11.1053 17.3249 10.9999 17.0597 10.9999H17.0497Z"
        fill="#666666"
      />
    </svg>
    <Booked
      :item="item"
      :selected_reached_lead_type="selected_reached_lead_type"
      :consultation_date="consultation_date"
      @reached_status_dialog="reached_status_dialog = $event"
      @book_information_dialog="reached_status_info_dialog = $event"
      @update_consultation_date="consultation_date = $event"
      @clear_selected_reached_lead_type="ClearSelectedReachedLeadType"
    />
    <svg
      v-if="
        selected_reached_lead_type === 'Call Back' &&
        !selected_second_reached_lead_type &&
        (String(item.trails?.['1st_trail']).toLowerCase() === 'replied' ||
          String(item.trails?.['2nd_trail']).toLowerCase() === 'replied' ||
          String(item.trails?.['3rd_trail']).toLowerCase() === 'replied')
      "
      @click="second_reached_status_dialog = true"
      class="cursor-pointer hoverd-plus-icon"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9902 22.5C11.525 22.5 11.067 22.4698 10.6182 22.4112L10.5535 22.907C9.58346 22.7805 8.65312 22.5276 7.77957 22.1653L7.97109 21.7035C7.11774 21.3496 6.32095 20.8863 5.59827 20.3309L5.29361 20.7274C4.53158 20.1418 3.84843 19.4587 3.26284 18.6966L3.6593 18.392C3.10395 17.6693 2.64065 16.8725 2.28678 16.0191L1.82492 16.2107C1.46267 15.3371 1.20975 14.4068 1.08321 13.4367L1.57901 13.372C1.52046 12.9232 1.49023 12.4653 1.49023 12C1.49023 11.5347 1.52046 11.0768 1.57901 10.628L1.08321 10.5633C1.20975 9.59323 1.46267 8.66289 1.82492 7.78933L2.28678 7.98086C2.64065 7.12751 3.10395 6.33072 3.6593 5.60804L3.26284 5.30337C3.84843 4.54134 4.53158 3.85819 5.29361 3.27261L5.59827 3.66907C6.32095 3.11371 7.11774 2.65042 7.9711 2.29655L7.77957 1.83469C8.65312 1.47244 9.58347 1.21951 10.5535 1.09297L10.6182 1.58877C11.067 1.53023 11.525 1.5 11.9902 1.5C12.4555 1.5 12.9134 1.53023 13.3623 1.58877L13.4269 1.09298C14.397 1.21951 15.3273 1.47244 16.2009 1.83469L16.0094 2.29655C16.8627 2.65042 17.6595 3.11371 18.3822 3.66907L18.6869 3.27261C19.4489 3.8582 20.132 4.54135 20.7176 5.30338L20.3212 5.60804C20.8765 6.33072 21.3398 7.12751 21.6937 7.98086L22.1555 7.78933C22.5178 8.66289 22.7707 9.59323 22.8973 10.5633L22.4015 10.628C22.46 11.0768 22.4902 11.5347 22.4902 12C22.4902 12.4653 22.46 12.9232 22.4015 13.372L22.8973 13.4367C22.7707 14.4068 22.5178 15.3371 22.1555 16.2107L21.6937 16.0191C21.3398 16.8725 20.8765 17.6693 20.3212 18.392L20.7176 18.6966C20.132 19.4587 19.4489 20.1418 18.6869 20.7274L18.3822 20.3309C17.6595 20.8863 16.8627 21.3496 16.0094 21.7035L16.2009 22.1653C15.3273 22.5276 14.397 22.7805 13.4269 22.907L13.3623 22.4112C12.9134 22.4698 12.4555 22.5 11.9902 22.5Z"
        stroke="#B3B3B3"
        stroke-dasharray="3 3"
      />
      <path
        d="M17.0497 10.9999H12.9997V6.93994C12.9997 6.67472 12.8943 6.42037 12.7068 6.23283C12.5193 6.0453 12.2649 5.93994 11.9997 5.93994C11.7345 5.93994 11.4801 6.0453 11.2926 6.23283C11.105 6.42037 10.9997 6.67472 10.9997 6.93994V10.9999H6.92969C6.66447 10.9999 6.41012 11.1053 6.22258 11.2928C6.03504 11.4804 5.92969 11.7347 5.92969 11.9999C5.92969 12.2652 6.03504 12.5195 6.22258 12.707C6.41012 12.8946 6.66447 12.9999 6.92969 12.9999H10.9997V17.0599C10.9997 17.3252 11.105 17.5795 11.2926 17.767C11.4801 17.9546 11.7345 18.0599 11.9997 18.0599C12.2649 18.0599 12.5193 17.9546 12.7068 17.767C12.8943 17.5795 12.9997 17.3252 12.9997 17.0599V12.9999H17.0597C17.3249 12.9999 17.5793 12.8946 17.7668 12.707C17.9543 12.5195 18.0597 12.2652 18.0597 11.9999C18.0597 11.7347 17.9543 11.4804 17.7668 11.2928C17.5793 11.1053 17.3249 10.9999 17.0597 10.9999H17.0497Z"
        fill="#666666"
      />
    </svg>
    <Booked
      :item="item"
      :selected_reached_lead_type="selected_second_reached_lead_type"
      :consultation_date="consultation_date"
      @reached_status_dialog="second_reached_status_dialog = $event"
      @book_information_dialog="reached_status_info_dialog = $event"
      @update_consultation_date="consultation_date = $event"
      @clear_selected_reached_lead_type="ClearSecondSelectedReachedLeadType"
    />
    <Confirmation
      :item="item"
      v-if="
        selected_reached_lead_type === 'Booked' ||
        selected_reached_lead_type === 'Cross/Up Selling' ||
        selected_reached_lead_type === 'Walk In'
      "
      :selected_reached_lead_type="selected_reached_lead_type"
    />
    <Confirmation
      :item="item"
      v-if="
        selected_second_reached_lead_type === 'Booked' ||
        selected_second_reached_lead_type === 'Cross/Up Selling' ||
        selected_second_reached_lead_type === 'Walk In'
      "
      :selected_reached_lead_type="selected_second_reached_lead_type"
    />
  </div>

  <!-- Dialog -->
  <v-dialog v-model="reached_status_dialog" max-width="850px">
    <v-card class="pa-4">
      <v-card-title
        class="d-flex justify-space-between align-center dialog-title"
      >
        <span class="title">Reached Leads</span>
        <span class="cursor-pointer" @click="reached_status_dialog = false">
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 1L1 11M1 1L11 11"
              stroke="#666666"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
      </v-card-title>
      <v-card-text>
        <div class="subtitle mb-3">Choose the type of reached lead</div>
        <v-row>
          <!-- Green Category -->
          <v-col
            cols="3"
            class="d-flex flex-column ga-3 reached-lead-type green"
          >
            <div
              @click="selected_reached_lead_type = 'Booked'"
              :class="[
                'cursor-pointer',
                selected_reached_lead_type === 'Booked' ? 'selected' : '',
              ]"
            >
              Booked
            </div>
            <div
              @click="selected_reached_lead_type = 'Cross/Up Selling'"
              :class="[
                'cursor-pointer',
                selected_reached_lead_type === 'Cross/Up Selling'
                  ? 'selected'
                  : '',
              ]"
            >
              Cross/Up Selling
            </div>
            <div
              @click="selected_reached_lead_type = 'Walk In'"
              :class="[
                'cursor-pointer',
                selected_reached_lead_type === 'Walk In' ? 'selected' : '',
              ]"
            >
              Walk In
            </div>
          </v-col>

          <!-- Gray Category -->
          <v-col
            cols="3"
            class="d-flex flex-column ga-3 reached-lead-type gray"
          >
            <div
              @click="selected_reached_lead_type = 'Call Back'"
              :class="[
                'cursor-pointer',
                selected_reached_lead_type === 'Call Back' ? 'selected' : '',
              ]"
            >
              Call Back
            </div>
            <div
              @click="selected_reached_lead_type = 'Outside'"
              :class="[
                'cursor-pointer',
                selected_reached_lead_type === 'Outside' ? 'selected' : '',
              ]"
            >
              Outside
            </div>
            <div
              @click="selected_reached_lead_type = 'Transfer / Branch'"
              :class="[
                'cursor-pointer',
                selected_reached_lead_type === 'Transfer / Branch'
                  ? 'selected'
                  : '',
              ]"
            >
              Transfer / Branch
            </div>
          </v-col>

          <!-- Orange Category -->
          <v-col
            cols="3"
            class="d-flex flex-column ga-3 reached-lead-type orange"
          >
            <div
              @click="selected_reached_lead_type = 'N/I Price'"
              :class="[
                'cursor-pointer',
                selected_reached_lead_type === 'N/I Price' ? 'selected' : '',
              ]"
            >
              N/I Price
            </div>
            <div
              @click="selected_reached_lead_type = 'N/I Service'"
              :class="[
                'cursor-pointer',
                selected_reached_lead_type === 'N/I Service' ? 'selected' : '',
              ]"
            >
              N/I Service
            </div>
            <div
              @click="selected_reached_lead_type = 'Inquiry'"
              :class="[
                'cursor-pointer',
                selected_reached_lead_type === 'Inquiry' ? 'selected' : '',
              ]"
            >
              Inquiry
            </div>
          </v-col>

          <!-- Red Category -->
          <v-col cols="3" class="d-flex flex-column ga-3 reached-lead-type red">
            <div
              @click="selected_reached_lead_type = 'Wrong Reservation'"
              :class="[
                'cursor-pointer',
                selected_reached_lead_type === 'Wrong Reservation'
                  ? 'selected'
                  : '',
              ]"
            >
              Wrong Reservation
            </div>
            <div
              @click="selected_reached_lead_type = 'Language Barrier'"
              :class="[
                'cursor-pointer',
                selected_reached_lead_type === 'Language Barrier'
                  ? 'selected'
                  : '',
              ]"
            >
              Language Barrier
            </div>
            <div
              @click="selected_reached_lead_type = 'Wrong Customer'"
              :class="[
                'cursor-pointer',
                selected_reached_lead_type === 'Wrong Customer'
                  ? 'selected'
                  : '',
              ]"
            >
              Wrong Customer
            </div>
            <div
              @click="selected_reached_lead_type = 'Duplicated'"
              :class="[
                'cursor-pointer',
                selected_reached_lead_type === 'Duplicated' ? 'selected' : '',
              ]"
            >
              Duplicated
            </div>
            <div
              @click="selected_reached_lead_type = 'N/A Number'"
              :class="[
                'cursor-pointer',
                selected_reached_lead_type === 'N/A Number' ? 'selected' : '',
              ]"
            >
              N/A Number
            </div>
            <div
              @click="selected_reached_lead_type = 'Closed'"
              :class="[
                'cursor-pointer',
                selected_reached_lead_type === 'Closed' ? 'selected' : '',
              ]"
            >
              Closed
            </div>
          </v-col>
        </v-row>
        <div class="d-flex justify-end">
          <span @click="selectReached" class="Choose-btn cursor-pointer"
            >Choose</span
          >
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
  <!-- Dialog -->
  <v-dialog v-model="second_reached_status_dialog" max-width="850px">
    <v-card class="pa-4">
      <v-card-title
        class="d-flex justify-space-between align-center dialog-title"
      >
        <span class="title">Reached Leads</span>
        <span
          class="cursor-pointer"
          @click="second_reached_status_dialog = false"
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 1L1 11M1 1L11 11"
              stroke="#666666"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
      </v-card-title>
      <v-card-text>
        <div class="subtitle mb-3">Choose the type of reached lead</div>
        <v-row>
          <!-- Green Category -->
          <v-col
            cols="3"
            class="d-flex flex-column ga-3 reached-lead-type green"
          >
            <div
              @click="selected_second_reached_lead_type = 'Booked'"
              :class="[
                'cursor-pointer',
                selected_second_reached_lead_type === 'Booked'
                  ? 'selected'
                  : '',
              ]"
            >
              Booked
            </div>
            <div
              @click="selected_second_reached_lead_type = 'Cross/Up Selling'"
              :class="[
                'cursor-pointer',
                selected_second_reached_lead_type === 'Cross/Up Selling'
                  ? 'selected'
                  : '',
              ]"
            >
              Cross/Up Selling
            </div>
            <div
              @click="selected_second_reached_lead_type = 'Walk In'"
              :class="[
                'cursor-pointer',
                selected_second_reached_lead_type === 'Walk In'
                  ? 'selected'
                  : '',
              ]"
            >
              Walk In
            </div>
          </v-col>

          <!-- Gray Category -->
          <v-col
            cols="3"
            class="d-flex flex-column ga-3 reached-lead-type gray"
          >
            <div style="color: #bbbaba">Call Back</div>
            <div
              @click="selected_second_reached_lead_type = 'Outside'"
              :class="[
                'cursor-pointer',
                selected_second_reached_lead_type === 'Outside'
                  ? 'selected'
                  : '',
              ]"
            >
              Outside
            </div>
            <div
              @click="selected_second_reached_lead_type = 'Transfer / Branch'"
              :class="[
                'cursor-pointer',
                selected_second_reached_lead_type === 'Transfer / Branch'
                  ? 'selected'
                  : '',
              ]"
            >
              Transfer / Branch
            </div>
          </v-col>

          <!-- Orange Category -->
          <v-col
            cols="3"
            class="d-flex flex-column ga-3 reached-lead-type orange"
          >
            <div
              @click="selected_second_reached_lead_type = 'N/I Price'"
              :class="[
                'cursor-pointer',
                selected_second_reached_lead_type === 'N/I Price'
                  ? 'selected'
                  : '',
              ]"
            >
              N/I Price
            </div>
            <div
              @click="selected_second_reached_lead_type = 'N/I Service'"
              :class="[
                'cursor-pointer',
                selected_second_reached_lead_type === 'N/I Service'
                  ? 'selected'
                  : '',
              ]"
            >
              N/I Service
            </div>
            <div
              @click="selected_second_reached_lead_type = 'Inquiry'"
              :class="[
                'cursor-pointer',
                selected_second_reached_lead_type === 'Inquiry'
                  ? 'selected'
                  : '',
              ]"
            >
              Inquiry
            </div>
          </v-col>

          <!-- Red Category -->
          <v-col cols="3" class="d-flex flex-column ga-3 reached-lead-type red">
            <div
              @click="selected_second_reached_lead_type = 'Wrong Reservation'"
              :class="[
                'cursor-pointer',
                selected_second_reached_lead_type === 'Wrong Reservation'
                  ? 'selected'
                  : '',
              ]"
            >
              Wrong Reservation
            </div>
            <div
              @click="selected_second_reached_lead_type = 'Language Barrier'"
              :class="[
                'cursor-pointer',
                selected_second_reached_lead_type === 'Language Barrier'
                  ? 'selected'
                  : '',
              ]"
            >
              Language Barrier
            </div>
            <div
              @click="selected_second_reached_lead_type = 'Wrong Customer'"
              :class="[
                'cursor-pointer',
                selected_second_reached_lead_type === 'Wrong Customer'
                  ? 'selected'
                  : '',
              ]"
            >
              Wrong Customer
            </div>
            <div
              @click="selected_second_reached_lead_type = 'Duplicated'"
              :class="[
                'cursor-pointer',
                selected_second_reached_lead_type === 'Duplicated'
                  ? 'selected'
                  : '',
              ]"
            >
              Duplicated
            </div>
            <div
              @click="selected_second_reached_lead_type = 'N/A Number'"
              :class="[
                'cursor-pointer',
                selected_second_reached_lead_type === 'N/A Number'
                  ? 'selected'
                  : '',
              ]"
            >
              N/A Number
            </div>
            <div
              @click="selected_second_reached_lead_type = 'Closed'"
              :class="[
                'cursor-pointer',
                selected_second_reached_lead_type === 'Closed'
                  ? 'selected'
                  : '',
              ]"
            >
              Closed
            </div>
          </v-col>
        </v-row>
        <div class="d-flex justify-end">
          <span @click="secondSelectReached" class="Choose-btn cursor-pointer"
            >Choose</span
          >
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
  <!-- Dialog -->
  <v-dialog v-model="reached_status_info_dialog" persistent max-width="500px">
    <v-card class="pa-4">
      <v-card-title
        class="d-flex justify-space-between align-center dialog-title"
      >
        <span class="title">Book Information</span>
        <span
          class="cursor-pointer"
          @click="reached_status_info_dialog = false"
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 1L1 11M1 1L11 11"
              stroke="#666666"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
      </v-card-title>
      <v-card-text>
        <div class="d-flex flex-column ga-3 mb-4">
          <div class="field d-flex flex-column ga-2">
            <label for="doctor_name">Doctor Name *</label>
            <input v-model="doctor_name" type="text" id="doctor_name" />
          </div>
          <div class="field d-flex flex-column ga-2">
            <label for="department_name">Department Name *</label>
            <input v-model="department_name" type="text" id="department_name" />
          </div>
          <div class="field d-flex flex-column ga-2">
            <label for="department_name">Service *</label>
            <v-autocomplete
              :items="[
                'Emergency Care',
                'Surgery',
                'Pediatrics',
                'Maternity and Obstetrics',
                'Oncology',
                'Orthopedics',
              ]"
              variant="outlined"
              v-model="service"
              hide-details
            ></v-autocomplete>
          </div>
          <div class="field d-flex flex-column ga-2 position-relative">
            <label for="consultation_date">Consultation Date *</label>
            <flatPickr v-model="consultation_date"></flatPickr>
          </div>
        </div>
        <div class="d-flex justify-end ga-3">
          <span @click="cancelReachedInfo" class="cancel-btn cursor-pointer"
            >Clear</span
          >
          <span @click="selectReachedInfo" class="Choose-btn cursor-pointer"
            >Save</span
          >
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import dashedAddIcon from "@/assets/images/icons/dashed-add.svg";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Booked from "@/components/crm/leads/options/Booked.vue";
import Confirmation from "@/components/crm/leads/options/confirmation.vue";
import apiClient from "@/core/buildRequest";
import { useLeadsStore } from "@/store/crm/useLeadsStore";
import { loginForm } from "@/store/logIn";

export default {
  components: { flatPickr, Booked, Confirmation },
  props: ["item"],
  name: "ProgressCol",
  data() {
    return {
      store: loginForm(),
      dashedAddIcon,
      reached_status_dialog: false,
      second_reached_status_dialog: false,
      reached_status_info_dialog: false,
      selected_reached_lead_type: this.item.reachedStatus,
      selected_second_reached_lead_type: this.item.secondReachedStatus,
      doctor_name: this.item.bookedInfo?.doctorName,
      department_name: this.item.bookedInfo?.departmentName,
      consultation_date: this.item.bookedInfo?.consultationDate,
      service: this.item.bookedInfo?.service,
    };
  },
  methods: {
    handleClickPermission() {
      if (!this.hasWritePermission) return;
      this.reached_status_dialog = true;
    },

    HavePermission(p) {
      return this.store?.permissions?.includes(p) || false;
    },

    selectReached() {
      this.$emit("selectReached", this.selected_reached_lead_type);
      if (
        this.selected_reached_lead_type === "Booked" ||
        this.selected_reached_lead_type === "Cross/Up Selling"
      ) {
        this.reached_status_info_dialog = true;
      }
      this.reached_status_dialog = false;
    },
    secondSelectReached() {
      this.$emit("secondSelectReached", this.selected_second_reached_lead_type);
      if (
        this.selected_second_reached_lead_type === "Booked" ||
        this.selected_second_reached_lead_type === "Cross/Up Selling"
      ) {
        this.reached_status_info_dialog = true;
      }
      this.second_reached_status_dialog = false;
    },
    async selectReachedInfo() {
      if (
        this.doctor_name &&
        this.consultation_date &&
        this.service &&
        this.department_name &&
        this.doctor_name !== "" &&
        this.consultation_date !== "" &&
        this.service !== "" &&
        this.department_name !== ""
      ) {
        this.$emit(
          "select-reached-info",
          this.doctor_name,
          this.department_name,
          this.consultation_date,
          this.service
        );
        await apiClient.post(`/leads-managment/booking/${this.item.id}`, {
          doctor_name: this.doctor_name,
          department: this.department_name,
          appointment_date: this.consultation_date,
          service: this.service,
        });
      }

      this.reached_status_info_dialog = false;
    },
    cancelReachedInfo() {
      this.doctor_name = "";
      this.department_name = "";
      this.service = "";
      this.consultation_date = "";
      this.reached_status_info_dialog = false;
    },
    ClearSelectedReachedLeadType() {
      this.selected_reached_lead_type = 0;
    },
    ClearSecondSelectedReachedLeadType() {
      this.selected_second_reached_lead_type = 0;
    },
  },
  watch: {
    consultation_date() {
      this.$emit(
        "select-reached-info",
        this.doctor_name,
        this.department_name,
        this.consultation_date,
        this.service
      );
    },
    async selected_reached_lead_type(val) {
      if (val !== this.item.reachedStatus) {
        console.log(val);
        try {
          await apiClient
            .post(`/leads-managment/update-progress-status/${this.item.id}`, {
              progress_status: val,
            })
            .then((response) => {
              let state = response.data.data.progress_status;
              if (
                state === "Booked" ||
                state === "Cross/Up Selling" ||
                state === "Walk In" ||
                state === "N/I Price" ||
                state === "N/I Service" ||
                state === "Inquiry"
              ) {
                apiClient
                  .post(
                    `/leads-managment/leads/update-reachability/${this.item.id}`,
                    {
                      reachablitiy: "reached",
                    }
                  )
                  .then((res) => {
                    const store = useLeadsStore();
                    store?.updateReachabilityStatus(this.item.id, "Reached");
                  });
              } else if (
                state === "Wrong Reservation" ||
                state === "Language Barrier" ||
                state === "Wrong Customer" ||
                state === "Duplicated" ||
                state === "N/A Number" ||
                state === "Closed"
              ) {
                apiClient
                  .post(
                    `/leads-managment/leads/update-reachability/${this.item.id}`,
                    {
                      reachablitiy: "missed",
                    }
                  )
                  .then((res) => {
                    const store = useLeadsStore();
                    store?.updateReachabilityStatus(this.item.id, "Missed");
                  });
              }
            });
        } catch (error) {}
      }
    },
    async selected_second_reached_lead_type(val) {
      if (val !== null && val !== undefined) {
        console.log(val);
        try {
          await apiClient
            .post(
              `/leads-managment/update-second-progress-status/${this.item.id}`,
              {
                second_progress_status: val,
              }
            )
            .then((response) => {
              let state = response.data.data.second_progress_status;

              if (
                state === "Booked" ||
                state === "Cross/Up Selling" ||
                state === "Walk In" ||
                state === "N/I Price" ||
                state === "N/I Service" ||
                state === "Inquiry"
              ) {
                apiClient
                  .post(
                    `/leads-managment/leads/update-reachability/${this.item.id}`,
                    {
                      reachablitiy: "reached",
                    }
                  )
                  .then((res) => {
                    let store = useLeadsStore();
                    store?.updateReachabilityStatus(this.item.id, "Reached");
                    if (state === "Walk In") {
                      const res = apiClient
                        .post(
                          `/leads-managment/update/booking-status/${this.item.id}`,
                          {
                            attendece_status: "attended",
                          }
                        )
                        .then((res) => {
                          let lead = store.leads.find(
                            (lead) => lead.id === this.item.id
                          );
                          if (lead) {
                            lead.attendanceStatus = "attended";
                          }
                        });
                    }
                  });
              } else if (
                state === "Wrong Reservation" ||
                state === "Language Barrier" ||
                state === "Wrong Customer" ||
                state === "Duplicated" ||
                state === "N/A Number" ||
                state === "Closed"
              ) {
                apiClient
                  .post(
                    `/leads-managment/leads/update-reachability/${this.item.id}`,
                    {
                      reachablitiy: "missed",
                    }
                  )
                  .then((res) => {
                    const store = useLeadsStore();
                    store?.updateReachabilityStatus(this.item.id, "Missed");
                  });
              }
            });
        } catch (error) {}
      }
    },
  },
  computed: {
    hasWritePermission() {
      return this.store?.permissions?.some((p) =>
        [
          "leads-managment.update",
          "leads-managment.create",
          "leads-managment.delete",
        ].includes(p)
      );
    },
    SelectedReachedLeadTypeClass() {
      let className = "";
      if (
        this.selected_reached_lead_type === "Call Back" ||
        this.selected_reached_lead_type === "Outside" ||
        this.selected_reached_lead_type === "Transfer / Branch" ||
        this.selected_reached_lead_type === "Visited"
      ) {
        className = "selected-gray";
      } else if (
        this.selected_reached_lead_type === "N/I Price" ||
        this.selected_reached_lead_type === "N/I Service" ||
        this.selected_reached_lead_type === "Inquiry"
      ) {
        className = "selected-orange";
      } else if (
        this.selected_reached_lead_type === "Wrong Reservation" ||
        this.selected_reached_lead_type === "Language Barrier" ||
        this.selected_reached_lead_type === "Wrong Customer"
      ) {
        className = "selected-red";
      }
      return className;
    },
  },
  mounted() {},
};
</script>

<style scoped>
.disabled-module {
  pointer-events: none;
  opacity: 0.5;
}
.title {
  font-size: 18px;
  font-weight: bold;
}

.cursor-pointer {
  cursor: pointer;
}

.dialog-title {
  padding-bottom: 20px;
  border-bottom: solid 0.1px #ececec;
}

.subtitle {
  font-size: 14px;
  font-weight: 400;
  line-height: 16.94px;
  color: #4d4d4d;
}

.reached-lead-type div,
.selected-gray,
.selected-red,
.selected-orange {
  height: 32px;
  padding: 2px 12px;
  border-radius: 16px;
  white-space: nowrap;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  display: flex;
  align-items: center;
  width: fit-content;
  border: solid 2px transparent;
}

.reached-lead-type.green div {
  background-color: #ecfdf3;
  color: #027a48;
}
.reached-lead-type.green div.selected {
  border-color: #034b2d;
}
.reached-lead-type.gray div,
.selected-gray {
  background-color: #f5f5f5;
  color: #4d4d4d;
}
.reached-lead-type.gray div.selected {
  border-color: #302f2f;
}

.reached-lead-type.orange div,
.selected-orange {
  background-color: #fffaeb;
  color: #c14a05;
}
.reached-lead-type.orange div.selected {
  border-color: #943b08;
}

.reached-lead-type.red div,
.selected-red {
  background-color: #fef3f2;
  color: #d91313;
}
.reached-lead-type.red div.selected {
  border-color: #8d0b0b;
}
.Choose-btn {
  width: 100px;
  height: 32px;
  padding: 2px 8px 2px 8px;
  border-radius: 8px;
  background: #237276;
  color: white;
  text-align: center;
}
.Choose-btn:hover {
  background: #144244;
}
.cancel-btn {
  width: 100px;
  height: 32px;
  padding: 2px 8px 2px 8px;
  border-radius: 8px;
  background: #f2f2f2;
  color: rgb(99, 99, 99);
  text-align: center;
}
.cancel-btn:hover {
  background: #aaaaaa;
}
.field label {
  font-size: 14px;
  font-weight: 400;
  line-height: 16.94px;
  color: #1a1a1a;
}
.field input {
  height: 40px;
  padding: 8px;
  gap: 161px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #e8e8e8;
}
</style>
<style>
.field .v-input .v-input__control .v-field .v-field__outline {
  color: #bbbbbb;
}
</style>
